import { useClipboard } from '@vueuse/core'

interface CopyContext {
  $toast: {
    success: (message: string) => void
  }
}

const useCopy = {
  methods: {
    /** copy text to clipboard and show toast confirmation */
    copy(this: CopyContext, textToCopy: string, silent: boolean = false): void {
      const { copy } = useClipboard()
      copy(textToCopy)
      if (!silent) {
        this.$toast.success('Copié !')
      }
    },
  },
}

export { useCopy }
